import { createAction, props } from '@ngrx/store';
import { FileInformation } from '../../shared/models/app-models';



export const addAttachment = createAction(
  '[Form Page] addAttachment',
  props<{ file: FileInformation }>()
);

export const updateAttachment = createAction(
  '[Form Page] updateAttachment',
  props<{ file: FileInformation; index: number }>()
);

export const deleteAttachment = createAction(
  '[Form Page] deleteAttachments',
  props<{ index: number }>()
);

export const getAllAttachment = createAction(
  '[Form Page] getAllAttachment',
  props<{ files: FileInformation[] }>()
);

export const  clearAttachmentStore = createAction('[Form Page] clearAttachmentStore');